// extracted by mini-css-extract-plugin
export default {"content":"_2DsfuS5u9I0N5B4U-EeJXj","dnsSection":"_1Q6c2i7rJPqRdXspaZpXCV"};